import { cookieToJson, UUID } from '~/util/index'

const IMObj = {
  twitter: 'Twitter',
  facebook: 'Facebook',
  youtube: 'Youtube',
  whatsapp: 'Group',
  ins: 'INS',
  telegram: 'Telegram'
}

export const state = () => {
  return {
    IMUrl: {},
    filterParams: []
  }
}

export const getters = {
  historys: (state) => state.app.historys,
  changeEpisodeHistory: (state) => state.play.changeEpisodeHistory,
  isClickPlay: (state) => state.play.isClickPlay,
  newSeries: (state) => state.play.newSeries,
  userInfo: (state) => state.user.userInfo,
  filterParams: (state) => state.filterParams,
  IMUrl: (state) => state.IMUrl,
  otherIMUrl: (state) => {
    const arr = []
    for (const [key, value] of Object.entries(state.IMUrl)) {
      console.log(`${key}: ${value}`)
      if (!['id', 'area', 'bcEmail', 'feedbackEmail', 'privacy'].includes(key)) {
        arr.push({
          label: IMObj[key],
          value
        })
      }
    }
    return arr
  },
  turingKey: (state) => state.app.turingKey
}

export const actions = {
  async nuxtServerInit({ commit, dispatch }, { req, app, route }) {
    app.$ServerBury({ buryEventId: 'UM_Event_WebDocRequest', buryParams: { ...req.headers, url: req.url } })
    let token = ''
    if (req.headers.cookie) {
      const parsed = cookieToJson(req.headers.cookie)
      try {
        token = parsed.token
      } catch (err) {
        // 找不到有效的Cookie
      }
    }
    commit('user/SET_TOKEN', token)
    commit('app/SET_UUID', UUID())
    commit(
      'app/SET_TURING',
      'KBgQDWCffTtEHjGe3dA6dLedsbSQAD5mQAVeXsSdnNWWtUPHLW+k04zBEWkuk3kRl2SWCRuuzq9SBcpBgG1lGBFSYgJrcWTTraxTVRrNYIsF6zwhZl1XKBagExtHVMPS3bHzCWS0mrWY7JWxn5ztneeXpar30GkOTn0i0lLY165RFkAwIDAQAB' //后期可通过服务端拿
    )
    let exclude = 'tv-'
    if (route.name.indexOf(exclude) == -1) {
      // tv页面不调用以下接口
      await dispatch('fetchIMUrl')
      await dispatch('fetchFilters')
    }
  },
  async fetchIMUrl({ commit }) {
    const info = await this.$api.querySnsByArea()
    commit('SET_IMUrl', info)
  },
  async fetchFilters({ commit }) {
    const res = await this.$api.getFilterParams()
    commit('SET_FILTER', res)
  }
}

export const mutations = {
  SET_IMUrl(state, IMUrl) {
    state.IMUrl = IMUrl
  },
  SET_FILTER(state, res) {
    state.filterParams = res
  }
}
